export default "__VITE_ASSET__CQbN4320__"